import Vue from 'vue'
import App from './App.vue'
import i18n from './lang'
import router from './router'
import store from './store'
import './utils/rem.js'

Vue.config.productionTip = false

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
